import { render, staticRenderFns } from "./error-info.vue?vue&type=template&id=a99cb166&scoped=true&"
import script from "./error-info.vue?vue&type=script&lang=js&"
export * from "./error-info.vue?vue&type=script&lang=js&"
import style0 from "./error-info.vue?vue&type=style&index=0&id=a99cb166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99cb166",
  null
  
)

export default component.exports